// extracted by mini-css-extract-plugin
module.exports = {"variants":"idt-selectedaccessoryforoptionsgroup_variants__1e_5x"};